document.addEventListener("DOMContentLoaded", () => {
    const faboriteBtns = document.querySelectorAll(".faborite_btn");
    const customerId = document.querySelector(".customerid").dataset.customer;
    faboriteBtns.forEach(btn => {
      btn.addEventListener("click", async() => {
        const variantId = btn.dataset.variant;
        let isDelete = btn.dataset.delete === "1" ? true : false;
          try {
            const response = await fetch("/apps/avielans/favorite_items", { 
              method: "POST",
              headers: { 
                "Content-Type": "application/json",
                'Aceess-Control-Allow-Origin': '*',
              },
              body: JSON.stringify({ variantId, customerId, isDelete }),
            });
            const data = await response.json();
            // console.log("レスポンス受信:", data);  // デバッグ用ログ
            if (data.success) {
              if(btn.dataset.delete === "1"){
                btn.dataset.delete = "0";
                btn.classList.remove("faborite_delete");
             }else{
               btn.dataset.delete = "1";
               btn.classList.add("faborite_delete");
             }
             if(btn.dataset.page === "1"){
               btn.parentElement.remove();
             } // デバッグ用ログ

            } else {
              alert(data.message);
            }
          } catch (error) {
            console.error("通信エラー:");  // デバッグ用ログ
          }
        });
    });
});

